<template>
  <div class="compressed-content">
    <h3 class="page-question">Have you ever had a positive diagnosis for COVID-19?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hadCovid19">
      <b-form-radio v-model="survey.medicalConditions.hadCovid19" name="covid19"
                    :value="true">
        Yes
      </b-form-radio>
      <b-form-radio v-model="survey.medicalConditions.hadCovid19" name="covid19"
                    :value="false">
        No
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      hadCovid19: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      hadCovid19() { return this.survey.medicalConditions.hadCovid19; }
    }
  };
</script>